/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M6.75 0C4.679 0 3 1.679 3 3.75v.825c-1.7117.3475-3 1.8608-3 3.675v12C0 22.3211 1.679 24 3.75 24h12c1.8142 0 3.3275-1.2883 3.675-3h.825c2.0711 0 3.75-1.6789 3.75-3.75V3.75C24 1.679 22.3211 0 20.25 0H6.75ZM18 20.25v-12C18 7.0074 16.9926 6 15.75 6h-12C2.5074 6 1.5 7.0074 1.5 8.25v12c0 1.2426 1.0074 2.25 2.25 2.25h12c1.2426 0 2.25-1.0074 2.25-2.25ZM4.5 4.5h11.25c2.0711 0 3.75 1.679 3.75 3.75V19.5h.75c1.2426 0 2.25-1.0074 2.25-2.25V3.75c0-1.2426-1.0074-2.25-2.25-2.25H6.75C5.5074 1.5 4.5 2.5074 4.5 3.75v.75Z"
    clipRule="evenodd"
  />,
  'Copy'
);
